import styled, { css } from "styled-components";

const btn = (light, dark) => css`
  white-space: nowrap;
  display: inline-block;
  border-radius: 5px;
  margin: 20px;
  min-width: 150px;
  padding: 5px 15px;
  font-size: 16px;
  color: white;
  padding: 10px 20px;
  &:visited {
    color: white;
  }
  background-image: linear-gradient(${dark}, ${dark});
  border: 1px solid ${dark};
  &:hover {
    background-image: linear-gradient(${dark}, ${dark});
    &[disabled] {
      background-image: linear-gradient(${dark}, ${dark});
    }
  }
  &:visited {
    color: black;
  }
  &[disabled] {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const btnDefault = css`
  ${btn("#ffffff", "#d5d5d5")} color: #FFF;
`;

const btnPrimary = btn("#3E7CB1", "#3E7CB1");

export default styled.div`
  font-family: "Lexend";

  h1 {
    text-align: center;
    color: #222;
  }

  h2 {
    text-align: center;
    color: #222;
  }

  & > div {
    text-align: center;
  }

  a {
    display: block;
    text-align: center;
    color: #222;
  }

  form {
    margin: 0px auto;
    padding: 0px;
    //box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
    //border-radius: 3px;

    .form-fields {
      display: flex;
      flex-flow: column nowrap;
      line-height: 1.6em;
      margin: 5px;
      & > label {
        color: #333;
        font-size: 1em;
        line-height: 32px;
        text-align: left;
      }
      & > input,
      & > select,
      & > textarea {
        flex: 1;
        padding: 10px;
        font-size: 1em;
        border: 1px solid #ccc;
        border-radius: 3px;
      }
      & > input[type="checkbox"] {
        margin-top: 7px;
      }
      & > div {
        margin-left: 16px;
        & > label {
          display: block;
          & > input {
            margin-right: 3px;
          }
        }
      }
      & > span {
        line-height: 32px;
        margin-left: 10px;
        color: #800;
        font-weight: bold;
      }
    }
    & > .buttons {
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      margin-top: 15px;
      border-radius: 3px;
    }

    button {
      margin: 0 10px;
      border-radius: 3px;
      &[type="submit"] {
        ${btnPrimary};
      }
      &[type="button"] {
        ${btnDefault};
      }
    }

    pre {
      border: 1px solid #ccc;
      background: rgba(0, 0, 0, 0.1);
      box-shadow: inset 1px 1px 3px rgba(0, 0, 0, 0.2);
      padding: 10px;
    }
  }
`;
